import cx from "classnames"
import PropTypes from "prop-types"
import React from "react"

function Container({ className, children, section, margin }) {
  const Tag = section ? "section" : "div"
  return (
    <Tag
      className={cx(className, "px-5 lg:container", {
        "my-20": !!margin,
      })}
    >
      {children}
    </Tag>
  )
}

Container.propTypes = {
  /** Additional className(s) */
  className: PropTypes.string,
  /** Content */
  children: PropTypes.node,
  /** If true, uses section tag */
  section: PropTypes.bool,
  /** If true, adds margins */
  margin: PropTypes.bool,
}

export default Container
